<template>
    <div>
        {{ display }}
    </div>
</template>

<script>
import { getLabel } from "@/features/schemas/services/labeller.js";

export default {
    types: [
        "entity"
    ],
    props: {
        value: {
            type:  Number,
            default: () => null,
        },
        options: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        display() {
            if (this.value == null) {
                return "";
            }
            if (!this.options?.lookup) {
                return getLabel(this.options.entityKey, this.value);
            }

            let item = this.options?.lookup[this.value.toString()];
            return getLabel(this.options.entityKey, item);
        },
    }
};
</script>
